<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 98%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="mini" placeholder="请输入姓名"
                        clearable></el-input>
                    <!-- <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                         style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select> -->

                    <el-select size="mini" v-model="formDatas.checkStatus" @change="partserch" placeholder="请选择审核状态"
                        style="width: 130px">
                        <el-option label="待审核" :value="1" key="1"></el-option>
                        <el-option label="在职" :value="2" key="2"></el-option>
                        <el-option label="离职" :value="3" key="3"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.auLevelDateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="离职开始日期" style="width: 130px" size="mini">
                    </el-date-picker> -
                    <el-date-picker v-model="formDatas.auLevelDateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="离职结束日期" style="width: 130px" size="mini">
                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 10px">更多搜索</el-button>
                    <el-dropdown size="mini" split-button type="warning" style="margin-left: 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
            </div>
            <!-- <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div> -->
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="auId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="max-height: 700px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="姓名">{{ DetailArr.auName }}</el-descriptions-item>
                        <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item>
                        <el-descriptions-item label="面试官">{{ DetailArr.auInterviewer }}</el-descriptions-item>
                        <el-descriptions-item label="所在部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <el-descriptions-item label="职务">{{ DetailArr.auPost }}</el-descriptions-item>
                        <el-descriptions-item label="性别">{{ DetailArr.auSex }}</el-descriptions-item>
                        <el-descriptions-item label="年龄">{{ DetailArr.auAge }}</el-descriptions-item>
                        <el-descriptions-item label="本人联系方式">{{ DetailArr.auContactMine }}</el-descriptions-item>
                        <el-descriptions-item label="入职时间">{{ DetailArr.auDateEntry }}</el-descriptions-item>
                        <el-descriptions-item label="试用期">{{ DetailArr.auProbationPeriod }}</el-descriptions-item>
                        <el-descriptions-item label="试用期结束时间">{{ DetailArr.auDateRegular }}</el-descriptions-item>
                        <el-descriptions-item label="转正描述">{{ DetailArr.auDateRegularDes }}</el-descriptions-item>
                        <el-descriptions-item label="认证通关/调整部门时间">{{ DetailArr.auDateTransfer }}</el-descriptions-item>
                        <el-descriptions-item label="转岗描述">{{ DetailArr.auDateTransferDes }}</el-descriptions-item>
                        <el-descriptions-item label="状态">{{ DetailArr.auStatus }}</el-descriptions-item>
                        <el-descriptions-item label="离职日期">{{ DetailArr.auLevelDate }}</el-descriptions-item>
                    </el-descriptions>

                    <p v-if="DetailArr.ajUserBorrowReturnList" style="width: 100%;text-align: center;margin: 10px 0;">
                        正在使用的设备</p>
                    <div v-if="DetailArr.ajUserBorrowReturnList" style="width: 100%;">
                        <ve-table ref="vetable" v-if="DetailArr.ajUserBorrowReturnList.length > 0" :columns="columnHis"
                            :table-data="DetailArr.ajUserBorrowReturnList" :max-height="400" :border-x="true"
                            :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            style="width: 100%;" />
                    </div>
                    <p v-if="DetailArr.ajClothesApplyList && DetailArr.ajClothesApplyList.length > 0"
                        style="width: 100%;text-align: center;margin: 10px 0;">工装申请记录
                        <span v-if="DetailArr.ajClothesApplyList && DetailArr.ajClothesApplyList.length > 0">
                            ({{ DetailArr.ajClothesApplyList[0].createtime }})
                        </span>
                    </p>
                    <div style="width: 100%;">
                        <ve-table ref="vetable"
                            v-if="DetailArr.ajClothesApplyItemList && DetailArr.ajClothesApplyItemList.length > 0"
                            :columns="columnsGg" :table-data="DetailArr.ajClothesApplyItemList" :max-height="400"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="acaiId"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajClothesApplyItemList && DetailArr.ajClothesApplyItemList.length == 0"
                            class="empty-data">
                            暂无工装</div>
                    </div>
                    <p v-if="DetailArr.ajAssetsKeyBorrowReturnList"
                        style="width: 100%;text-align: center;margin: 10px 0;">正在使用的钥匙</p>
                    <div v-if="DetailArr.ajAssetsKeyBorrowReturnList" style="width: 100%;">
                        <ve-table ref="vetable" v-if="DetailArr.ajAssetsKeyBorrowReturnList.length > 0"
                            :columns="columnsDetail" :table-data="DetailArr.ajAssetsKeyBorrowReturnList"
                            :max-height="400" :border-x="true" :border-y="true" :scrollWidth="10"
                            :cell-style-option="cellStyleOption" style="width: 100%;" />
                    </div>
                </div>
            </el-dialog>
            <!-- 添加关联 -->
            <el-dialog title="关联资产" :visible.sync="Related" width="30%" :before-close="handleClose">
                <div style="width: 70%; margin: 10px auto;">
                    <!-- <el-select v-model="form.aaId" placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in aaTypearr || []" :label="item.aaName" :value="item.aaId" :key="item.aaId">
                        </el-option>
                    </el-select> -->
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="Related = false">取 消</el-button>
                    <el-button type="primary" @click="sureRelated">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 98%; height:400px;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="130px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.auName" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="入职时间">
                                    <el-date-picker v-model="formDatas.auDateEntryStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateEntryEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="试用期结束时间">
                                    <el-date-picker v-model="formDatas.auDateRegularStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateRegularEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="认证通关/调整部门时间">
                                    <el-date-picker v-model="formDatas.auDateTransferStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auDateTransferEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="离职时间">
                                    <el-date-picker v-model="formDatas.auLevelDateStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.auLevelDateEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="部门">
                                    <el-input v-model="formDatas.auDepartment" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>

                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="工装类型">
                                    <el-select v-model="formDatas.auClothesType" clearable placeholder="请选择"
                                        style="width: 230px">
                                        <el-option label="七件套" :value="1" key="1"></el-option>
                                        <el-option label="九件套" :value="2" key="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="工装领取状态">
                                    <el-select v-model="formDatas.auClothesStatus" clearable placeholder="请选择"
                                        style="width: 230px">
                                        <el-option label="未领取" :value="1" key="1"></el-option>
                                        <el-option label="已申请" :value="2" key="2"></el-option>
                                        <el-option label="已领取" :value="3" key="3"></el-option>
                                        <el-option label="已放弃" :value="4" key="4"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="职务">
                                    <el-input v-model="formDatas.auPost" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="性别">
                                    <el-select v-model="formDatas.auSex" clearable @change="partserch" placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="男" value="男" key="1"></el-option>
                                        <el-option label="女" value="女" key="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="本人联系方式">
                                    <el-input v-model="formDatas.auContactMine" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="状态">
                                    <el-input v-model="formDatas.auStatus" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="电脑包领取状态">
                                    <el-select v-model="formDatas.auPackStatus" clearable placeholder="请选择"
                                        style="width: 230px">
                                        <el-option label="未领取" :value="1" key="1"></el-option>
                                        <el-option label="已领取" :value="2" key="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                        </el-form>

                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <el-button type="primary" @click="partserch(), IsSerch = false"
                        style="margin-left: 100px">立即搜索</el-button>
                    <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                </div>
            </el-dialog>

            <!-- 编辑日期 -->
            <el-dialog title="编辑" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-select v-model="dateUpdata" placeholder="请选择" v-if="TypeId == 2">
                    <el-option v-for="item in EditArr || []" :label="item.key" :value="item.value" :key="item.id">
                    </el-option>
                </el-select>
                <el-select v-if="TypeId == 3" v-model="dateUpdata" placeholder="请选择">
                    <el-option v-for="item in auNationArr || []" :label="item.snName" :value="item.snName"
                        :key="item.snId">
                    </el-option>
                </el-select>

                <el-date-picker v-if="TypeId == 1" v-model="dateUpdata" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 借还记录 -->
            <el-dialog title="借还记录" :visible.sync="IsHistory" width="70%" top="8vh">
                <ve-table ref="vetable" v-if="HistoryData" :columns="columnHis" :table-data="HistoryData"
                    :max-height="500" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" style="width: 100%" />
                <div v-show="HistoryData.length == 0" class="empty-data">暂无数据</div>
                <p style="width: 100%;margin:15px auto;text-align: center;font-size: 20px;">资产借用登记表</p>
                <ve-table ref="vetable" v-if="DjbData" :columns="columnDjb" :table-data="DjbData" :max-height="500"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    style="width: 100%" />
            </el-dialog>
            <!-- 上传图片 -->
            <el-dialog title="上传图片" :visible.sync="IsImg" width="50%" top="8vh">
                <div v-if="type == 1">
                    <p>上传身份证正面(人像面)</p>
                    <my-upload ref="upcard2" @fileChange="auIdcardUpfileChangeTwo" :filearr="UpfileList" :limit="limit"
                        @removeAfter="UpremoveAfter" apiType="cardUp" style="margin: 10px 5px 5px;">
                    </my-upload>
                    <div>
                        <p>上传身份证反面(国徽面)</p>
                        <my-upload ref="Downcard2" @fileChange="auIdcardDownfileChange" :filearr="DownfileList"
                            :limit="limit" apiType="cardDown" style="margin: 10px 5px 5px;">
                        </my-upload>
                    </div>
                </div>
                <div v-if="type == 2">
                    <p>上传学历证书</p>
                    <my-upload ref="xlupload2" @fileChange="XlfileChange" :filearr="xlfileList" :limit="limit"
                        style="margin: 10px 5px 5px;">
                    </my-upload>
                    <div>
                        <p>上传学历查验证明</p>
                        <my-upload ref="Cyupload2" @fileChange="CyfileChange" :filearr="CyfileList" :limit="limit"
                            style="margin: 10px 5px 5px;">
                        </my-upload>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseImg">取 消</el-button>
                    <el-button type="primary" @click="sureImg">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 离职 -->
            <el-dialog title="用户离职" :visible.sync="IsLevel" width="50%" top="8vh">
                <div style="width: 100%; height: 100%; padding: 5%">
                    <el-form ref="formDatas" :model="formLevel" label-position="left" label-width="130px"
                        @submit.native.prevent>

                        <el-form-item label="离职原因">
                            <el-input v-model="formLevel.auLeaveReason" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="离职日期">

                            <el-date-picker v-model="formLevel.auLevelDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否发薪">
                            <el-input v-model="formLevel.auPayStatus" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="社保备注">
                            <el-input v-model="formLevel.auDesLeaveSocialSecurityDes" style="width: 80%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseLevel">取 消</el-button>
                    <el-button type="primary" @click="sureLevel">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑资料 -->
            <el-dialog title="编辑资料" :visible.sync="IsConact" width="50%" top="8vh">
                <div style="width: 100%; height: 100%; padding: 5%">
                    <el-form ref="formConact" :model="form" label-position="left" label-width="130px"
                        @submit.native.prevent>
                        <div v-if="conactType == 1">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">银行卡信息</div>
                            <!-- <el-form-item label="浦发银行卡号">
                                <el-input v-model="form.auBankCardPf" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="其他银行">
                                <el-input v-model="form.auBankCardOther" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="卡号">
                                <el-input v-model="form.auBankCardOtherNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行">
                                <el-input v-model="form.auBankCardOtherOpen" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div v-if="conactType == 2">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">家庭信息</div>
                            <el-form-item label="父亲姓名">
                                <el-input v-model="form.auContactDad" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲工作单位">
                                <el-input v-model="form.auContactDadUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="父亲联系方式">
                                <el-input v-model="form.auContactDadPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲姓名">
                                <el-input v-model="form.auContactMom" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲工作单位">
                                <el-input v-model="form.auContactMomUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="母亲联系方式">
                                <el-input v-model="form.auContactMomPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="兄弟姐妹姓名">
                                <el-input v-model="form.auContactSibling" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹工作单位">
                                <el-input v-model="form.auContactSiblingUnit" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="兄弟姐妹联系方式">
                                <el-input v-model="form.auContactSiblingPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                        </div>
                        <div v-if="conactType == 3">
                            <div style="width: 90%;margin: 15px auto;text-align: center;">同城紧急联系人信息</div>
                            <el-form-item label="同城紧急联系人姓名">
                                <el-input v-model="form.auContactEmergency" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="同城紧急联系人联系方式">
                                <el-input v-model="form.auContactEmergencyPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>

                        </div>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="CloseConact">取 消</el-button>
                    <el-button type="primary" @click="sureConact">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 批量修改部门  -->
            <el-dialog title="编辑部门" :visible.sync="Isdepartment" width="60%" :before-close="IsdepartmentClose"
                style="margin-left: 200px;z-index: 99;">
                <el-cascader v-model="auDepartment" :options="auDepartmentArr" :show-all-levels="false"
                    :props="{ checkStrictly: true }"></el-cascader>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="IsdepartmentClose">取 消</el-button>
                    <el-button type="primary" @click="sureIsdepartment">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑工装信息  -->
            <el-dialog title="工装信息" :visible.sync="IsWorkClothes" width="60%" :before-close="IsWorkClothesClose"
                style="margin-left: 200px;z-index: 99;">
                <el-form ref="formWC" :model="formWC" label-position="left" label-width="130px" @submit.native.prevent>
                    <el-form-item label="工装类型" prop="auClothesType">
                        <el-select v-model="formWC.auClothesType" placeholder="请选择">
                            <el-option label="七件套" :value="1"></el-option>
                            <el-option label="九件套" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工装领取状态" prop="auClothesStatus">
                        <el-select v-model="formWC.auClothesStatus" placeholder="请选择">
                            <el-option label="未领取" :value="1"></el-option>
                            <el-option label="已申请" :value="2"></el-option>
                            <el-option label="已领取" :value="3"></el-option>
                            <el-option label="已放弃" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工装领取状态描述" prop="auClothesStatusDes">
                        <el-input v-model="formWC.auClothesStatusDes" style="width: 50%;" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="IsWorkClothesClose">取 消</el-button>
                    <el-button type="primary" @click="sureIsWorkClothes">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑电脑包信息  -->
            <el-dialog title="电脑包信息" :visible.sync="isDnb" width="60%" :before-close="IsDnbClothesClose"
                style="margin-left: 200px;z-index: 99;">
                <el-form ref="formDnb" :model="formDnb" label-position="left" label-width="150px"
                    @submit.native.prevent>
                    <el-form-item label="电脑包状态" prop="auPackStatus">
                        <el-select v-model="formDnb.auPackStatus" placeholder="请选择">
                            <el-option label="未领取" :value="1"></el-option>
                            <el-option label="已领取" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电脑包回收状态描述" prop="auPackReturnStatus">
                        <el-select v-model="formDnb.auPackReturnStatus" placeholder="请选择">
                            <el-option labl="是" value="是"></el-option>
                            <el-option label="否" value="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="工装领取状态描述" prop="auClothesStatusDes">
                        <el-input v-model="formWC.auClothesStatusDes" style="width: 50%;" placeholder="请输入"></el-input>
                    </el-form-item> -->
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="IsDnbClothesClose">取 消</el-button>
                    <el-button type="primary" @click="sureIsDnbClothes">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {
    addAjUserPostRecord, getAjUserPostRecordList, updateAjUserPostRecord, getAssetsAjUserSyn,
    updateAjUserClothes, addAjUser, updateAjUser, deleteAjUser, getAjUserDepartmentList,
    getSysNationList, exportAjUserWord, uploadAjUser, getAjUserDetails, updateAjUserDepartments,
    updateAjFittingsAssetsUnbinding, updateAjFittingsAssets, updateAjUserCheck,
    uploadImportAjUser, exportAjUserAssets, getAjUserBorrowReturnList, updateAjUserIdCard, updateAjUserCertificate,
    getSysRegionList, getAjUserWordList, updateAjUserWord, updateAjUserLeave, updateAjUserBank, updateAjUserContact,
    getAjUserItem, getAjUserBelongList, getAjUserListAssets, updateAjUserPack, getAjUserExpandDetails,

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            columnsDetail: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aakName",
                    key: "aakName",
                    title: "型号名称",
                    align: "center",
                    edit: true,
                },
                {
                    field: "aakNumber",
                    key: "aakNumber",
                    title: "钥匙编码",
                    align: "center",
                    edit: true,
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "当前使用人",
                    align: "center",
                },
                {
                    field: "aakbrBorrowDate",
                    key: "aakbrBorrowDate",
                    title: "领用日期",
                    align: "center",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    <span> {row.aakbrBorrowDate}</span>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "aakbrBorrowStatus",
                    key: "aakbrBorrowStatus",
                    title: "状态",
                    width: 90,
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                            <span>
                                {
                                    row.aakbrBorrowStatus == 1 ? <el-tag type="success">使用中</el-tag> :
                                        (row.aakbrBorrowStatus == 2 ? <el-tag type="danger">已归还</el-tag> :
                                            (row.aakbrBorrowStatus == 3 ? <el-tag type="danger">已损坏</el-tag> :
                                                <el-tag type="info">已丢失</el-tag>))
                                }
                            </span>
                        );
                    },
                },

            ],
            isDnb: false,
            formDnb: {
                auPackStatus: '',
                auPackReturnStatus: '',
            },
            IsWorkClothes: false,
            formWC: {
                auClothesType: '',
                auClothesStatus: '',
                auClothesStatusDes: '',
            },
            columnHis: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 160
                },
                {
                    field: "aubrThisName",
                    key: "aubrThisName",
                    title: "借用物品名称",
                    align: "center",
                    // fixed:'left',
                    width: 160
                },
                {
                    field: "aubrThisNumber",
                    key: "aubrThisNumber",
                    title: "资产编码",
                    align: "center",
                    // fixed:'left',
                    width: 160
                },
                {
                    field: "aubrType",
                    key: "aubrType",
                    title: "物品类型",
                    align: "center",
                    width: 120,
                    // fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-tag type="primary"  >
                                    {row.aubrType == 1 ? '资产' : row.aubrType == 2 ? '配件' : row.aubrType == 3 ? '耗材' : '手机卡'}
                                </el-tag>

                            </span>
                        );
                    },
                },

                {
                    field: "aubrBorrowReturn",
                    key: "aubrBorrowReturn",
                    title: "状态",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubrBorrowReturn == 1 ? <el-tag size="mini" type="danger" > 领用 </el-tag> : row.aubrBorrowReturn == 2 ? <el-tag size="mini" type="danger" > 借用 </el-tag> : <el-tag size="mini" type="success" > 已还 </el-tag>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "aubrBorrowStatus",
                    key: "aubrBorrowStatus",
                    title: "借用状态",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aubrBorrowStatus == 1 ? <el-tag size="mini" type="danger" > 使用中 </el-tag> : <el-tag size="mini" type="success" > 已归还 </el-tag>
                                }


                            </span>
                        );
                    },

                },
                { field: "aubrThisDes", key: "aubrThisDes", title: "备注", width: 200, align: "center" },
                { field: "returntime", key: "returntime", title: "归还时间", width: 160, align: "center" },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ],
            columnDjb: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "fileUrl",
                    key: "fileUrl",
                    title: "图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fileUrl ? <el-image ref="scrImg" id="scrimg" src={row.fileUrl} alt="" fit="fill" style="width: 80px;height: 80px;"
                                        previewSrcList={[row.fileUrl]}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },

            ],
            aubName_arr: [],
            Isdepartment: false,
            auDepartmentArr: [],
            auDepartment: '',
            updatamsg: '暂无数据',
            updataData: [],
            columnsGg: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNum",
                    key: "acaiNum",
                    title: "数量",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiChildAcwsName",
                    key: "acaiChildAcwsName",
                    title: "子级工装规格",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildStatus",
                    key: "acaiChildStatus",
                    title: "子级状态",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildDes",
                    key: "acaiChildDes",
                    title: "内部交换描述",
                    align: "center",
                    width: 200,
                    edit: false,
                },
                {
                    field: "acaiType",
                    key: "acaiType",
                    title: "类型",
                    align: "center",
                    width: 70,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiType == 2 ? (
                                    <el-tag size="mini" type="danger">
                                        更换
                                    </el-tag>
                                ) : row.acaiType == 1 ? (
                                    <el-tag size="mini" type="primary">
                                        新建
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="warning">
                                        内部交换
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                {
                    field: "acaiStatus",
                    key: "acaiStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiStatus == 0 ? (
                                    <el-tag size="mini" type="info">
                                        不需要
                                    </el-tag>
                                ) : row.acaiStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaiStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaiStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaiStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                            </span>

                        )
                    },
                },
            ],
            Isupdata: false,
            editTf: false,
            formTf: {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            },
            AddtransferShow: false,
            transferData: [],

            transferShow: false,
            IsConact: false,
            conactType: 0,
            formLevel: {

            },
            IsLevel: false,
            wordType: '',
            wordtypenum: 1,
            wordData: [],
            IsWord: false,
            bankShow: '',
            familyShow: [],
            education: '全日制',
            auAddressNowPL: '请选择地区',
            auAddressNowvalue: '',
            auAddressNowDetail: '',
            auOriginPL: '请选择地区',
            auOriginvalue: '',
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(node);
                    const { level } = node;
                    getSysRegionList({ srSuperiorCode: node.value }).then(res => {
                        const nodes = res.data.map(item => ({
                            value: item.srCode,
                            label: item.srName,
                            leaf: level >= 2
                        }))
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    })

                }
            },
            auOriginArr: [],
            type: '',
            IsImg: false,
            TypeId: 0,
            EditArr: [],

            HistoryData: [],
            DjbData: [],
            IsHistory: false,
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],

            bulkImport: false,

            dateUpdata: '',
            dbtrue: false,

            xlfileList: [],
            CyfileList: [],
            limit: 1,
            UpfileList: [],
            DownfileList: [],
            upload: false,
            // 名族
            auNationArr: [],
            // 婚姻状态
            auMaritalArr: [
                {
                    id: 1,
                    value: "未婚",
                    key: '未婚',
                },
                {
                    id: 2,
                    value: "已婚",
                    key: '已婚',
                },
                {
                    id: 3,
                    value: "离异",
                    key: '离异',
                },
            ],
            // 户口性质
            auAddressRegisteredTypeArr: [
                {
                    id: 1,
                    value: "城镇户口",
                    key: '城镇户口',
                },
                {
                    id: 2,
                    value: "农村户口",
                    key: '农村户口',
                },
                {
                    id: 3,
                    value: "其他",
                    key: '其他',
                }
            ],
            // 政治面貌
            auPoliticalArr: [
                {
                    id: 1,
                    value: '中国共产党员',
                    key: '中国共产党员',
                },
                {
                    id: 2,
                    value: '共青团员',
                    key: '共青团员',
                },
                {
                    id: 3,
                    value: '群众',
                    key: '群众',
                },
            ],

            // 试用期
            auprobationArr: [{
                id: 0,
                value: 0,
                key: '没有使用期',
            },
            {
                id: 1,
                value: 1,
                key: '一个月',
            },
            {
                id: 2,
                value: 2,
                key: '二个月',
            },
            {
                id: 3,
                value: 3,
                key: '三个月',
            },
            {
                id: 4,
                value: 4,
                key: '四个月',
            },
            {
                id: 5,
                value: 5,
                key: '五个月',
            },
            {
                id: 6,
                value: 6,
                key: '六个月',
            },
            ],

            Related: false,
            afcTypearr: [],
            aacTypearr: [],
            aaTypearr: [],//
            amTypearr: [],//厂商
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {

            },
            rules: {
                afName: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }
                ],
                afNumber: [{
                    required: true,
                    message: '请输入编号',
                    trigger: 'blur'
                }
                ],
            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            editOption2: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange2(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            tableDataCopy: [],
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "auBelong",
                    key: "auBelong",
                    title: "归属",
                    width: 80,
                    align: "center",
                    edit: true,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auBelongListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auBelongListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auBelong')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auNameListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auNameListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auName')
                                console.log(nextVisible);
                            }

                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.auId)}
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auIdcard",
                    key: "auIdcard",
                    title: "身份证号码",
                    align: "center",
                    width: 160,
                    edit: false,

                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "所在部门",
                    width: 200,
                    align: "center",
                    edit: false,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDepartmentListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDepartmentListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auDepartment')
                                console.log(nextVisible);
                            }
                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="display:flex;">
                                <div style="width:100%;">{row.auDepartment}</div>
                            </div>
                        );
                    },

                },
                {
                    field: "auPost",
                    key: "auPost",
                    title: "职务",
                    align: "center",
                    width: 100,
                    edit: true,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                    },
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auPostListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auPostListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auPost')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 70,
                    edit: true,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auSexListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auSexListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auSex')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                {
                    field: "dingJobNumber",
                    key: "dingJobNumber",
                    title: "公司钉钉手机号",
                    align: "center",
                    width: 120,
                    edit: true,

                },
                {
                    field: "amcNumber",
                    key: "amcNumber",
                    title: "公司卡号",
                    align: "center",
                    width: 100,
                    edit: true,

                },
                {
                    field: "auContactMine",
                    key: "auContactMine",
                    title: "本人联系方式",
                    align: "center",
                    width: 100,
                    edit: true,

                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auClothesType == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        七件套
                                    </el-tag>
                                ) : row.auClothesType == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        九件套
                                    </el-tag>
                                ) : ''}

                            </span>
                        )
                    },
                },

                {
                    field: "auClothesStatusDes",
                    key: "auClothesStatusDes",
                    title: "工装领取状态描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                {
                    field: "auClothesFeiDes",
                    key: "auClothesFeiDes",
                    title: "工装费用描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                {
                    field: "auClothesStatus",
                    key: "auClothesStatus",
                    title: "工装领取状态",
                    align: "center",
                    width: 150,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auClothesStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        未领取
                                    </el-tag>
                                ) : row.auClothesStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        已申请
                                    </el-tag>
                                ) : row.auClothesStatus == 3 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        已放弃
                                    </el-tag>
                                )}
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red;marginLeft:5px;"
                                    on-click={() => this.handleWc(row)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        )
                    },
                },
                {
                    field: "auPackStatus",
                    key: "auPackStatus",
                    title: "电脑包领取状态",
                    align: "center",
                    width: 150,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.auPackStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        未领取
                                    </el-tag>
                                ) : row.auPackStatus == 2 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : ''}
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red;marginLeft:5px;"
                                    on-click={() => this.handleDnb(row)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        )
                    },
                },
                {
                    field: "auPackFeiDes",
                    key: "auPackFeiDes",
                    title: "电脑包费用描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                {
                    field: "auPackReturnStatus",
                    key: "auPackReturnStatus",
                    title: "电脑包回收状态描述",
                    align: "center",
                    width: 150,
                    edit: false,

                },
                // {
                //     field: "auAge",
                //     key: "auAge",
                //     title: "年龄",
                //     align: "center",
                //     width: 100,
                //     edit: true,

                // },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDateEntryListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDateEntryListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auDateEntry')
                                console.log(nextVisible);
                            }
                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateEntry, 'auDateEntry', rowIndex, row.auId, 1)}>{row.auDateEntry}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "auDateRegular",
                    key: "auDateRegular",
                    title: "试用期结束时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDateRegularListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDateRegularListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auDateRegular')
                                console.log(nextVisible);
                            }
                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateRegular, 'auDateRegular', rowIndex, row.auId, 1)}>{row.auDateRegular}</div>
                            </span>
                        );
                    },

                },
                {
                    field: "auDateTransfer",
                    key: "auDateTransfer",
                    title: "认证通关/调整部门时间",
                    align: "center",
                    edit: false,
                    width: 90,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDateTransferListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDateTransferListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auDateTransfer')
                                console.log(nextVisible);
                            }
                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.auDateTransfer, 'auDateTransfer', rowIndex, row.auId, 1)}>{row.auDateTransfer}</div>
                            </span>
                        );
                    },

                },
                // 在职时间
                {
                    field: "auDateEntryDays",
                    key: "auDateEntryDays",
                    title: "在职时间",
                    align: "center",
                    width: 100,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDateEntryDaysListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDateEntryDaysListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auDateEntryDays')
                                console.log(nextVisible);
                            }
                        }
                    },
                },

                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    edit: true,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auStatusListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auStatusListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auStatus')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                // 转正倒计时
                {
                    field: "auProbationDaysDes",
                    key: "auProbationDaysDes",
                    title: "转正倒计时",
                    align: "center",
                    width: 120,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auProbationDaysDesListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auProbationDaysDesListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auProbationDaysDes')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                { field: "auInterviewer", key: "auInterviewer", title: "面试官", width: 100, align: "center" },
                {
                    field: "auLevelDate",
                    key: "auLevelDate",
                    title: "离职日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.auLevelDate}</div>
                            </span>
                        );
                    },
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auLevelDateListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auLevelDateListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob('auLevelDate')
                                console.log(nextVisible);
                            }
                        }
                    },

                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "checkStatus",
                    key: "checkStatus",
                    title: "审核",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.checkStatus == 2 ? <el-tag type="success" size="mini">已审核</el-tag> : row.checkStatus == 1 ? <el-tag type="danger" size="mini">未审核</el-tag> :

                                        <el-tag type="danger" size="mini">离职</el-tag>}

                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 140,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>

                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleHistory(row)}
                                >
                                    借用记录
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            auId: '',
            formDatas: {
                auClothesType: '',
                auClothesStatus: '',
                auNameListString: '',
                auBelongListString: '',
                auDepartmentListString: '',
                auPostListString: '',
                auSexListString: '',
                auDateEntryListString: '',
                auProbationPeriodListString: '',
                auDateRegularListString: '',
                auDateTransferListString: '',
                auStatusListString: '',
                auInterviewerListString: '',
                auDateExpirationContractListString: '',



                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auContactMine: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                auDateRegularStart: '',
                auDateRegularEnd: '',
                auDateTransferStart: '',
                auDateTransferEnd: '',
                auLevelDateStart: '',
                auLevelDateEnd: '',
                checkStatus: 2,
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {

        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getSysNationList().then(res => {
            this.auNationArr = res.data
        })
        getAjUserBelongList().then(res => {
            this.aubName_arr = res.data
        })
        getSysRegionList().then(res => {
            res.data.forEach((item, index) => {
                const obj = {
                    value: item.srCode,
                    label: item.srName,
                    children: [],
                }
                this.auOriginArr.push(obj)
            })

        })
        getAjUserDepartmentList({ pageSize: 0 }).then((res) => {
            res.data.forEach((item, index) => {
                const s = {
                    value: item.audId,
                    label: item.audName,
                }
                if (item.ajUserDepartmentListChild.length > 0) {
                    s.children = []
                    item.ajUserDepartmentListChild.forEach((data, id) => {
                        const ss = {
                            value: data.audId,
                            label: data.audName,
                        }

                        s.children.push(ss)
                    })
                };
                this.auDepartmentArr.push(s)
            })
        });

        this.getList();
    },
    mounted() {


    },
    methods: {
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjUserAssets({ ...this.formDatas, userStatus: this.formDatas.checkStatus - 1, auIds: this.selectedRowKeysCollection.toString(), exportType: 2, }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjUserAssets({ ...this.formDatas, userStatus: this.formDatas.checkStatus - 1, exportType: 1 }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        RosterBatchDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjUser({ auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        IsdepartmentClick() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.Isdepartment = true;
            }
        },
        IsdepartmentClose() {
            this.Isdepartment = false
            this.auDepartment = '';
        },
        IsWorkClothesClose() {
            this.IsWorkClothes = false
            this.formWC = {
                auClothesType: '',
                auClothesStatus: '',
                auClothesStatusDes: '',
            };
        },
        IsDnbClothesClose() {
            this.isDnb = false
            this.formDnb = {
                auPackStatus: '',
                auPackFeiDes: '',
                auPackReturnStatus: '',
            };
        },
        sureIsdepartment() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var formdata = this.auDepartment[0] || this.auDepartment;
                    if (this.auDepartment.length > 1) {
                        formdata = this.auDepartment[this.auDepartment.length - 1]
                    }
                    updateAjUserDepartments({ audId: formdata, auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                            });
                            this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = [];
                            this.IsdepartmentClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureIsWorkClothes() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserClothes(this.formWC).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                            });
                            this.IsWorkClothesClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureIsDnbClothes() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserPack(this.formDnb).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                            });
                            this.IsDnbClothesClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        batchWord() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjUserWord({ auIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            }
        },
        IsupdataClose() {
            this.Isupdata = false;
            this.updataData = []
            this.updatamsg = '暂无数据';
            this.getList();
        },
        SynchronizeUpdates() {
            this.openLoading()

            getAssetsAjUserSyn({ auIds: this.selectedRowKeysCollection.toString() })
                .then(res => {
                    if (res.data == "2") {
                        this.loadings.close();
                        this.$message({
                            type: "wraning",
                            message: "用户已审核!",
                        });
                    } else if (Array.isArray(res.data)) {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updataData = res.data;
                    } else {
                        this.loadings.close();
                        this.Isupdata = true;
                        this.updatamsg = res.data;

                    }
                })

        },
        transferShowClose() {
            this.transferShow = false;
            this.getList()
        },
        transferList() {
            getAjUserPostRecordList({ auId: this.auId }).then(res => {
                this.transferData = res.data;
            })
        },
        transferEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formTf = data;
            this.editTf = true;
            this.AddtransferShow = true;
        },
        AddtransferClick() {
            this.formTf.auId = this.auId;
            this.AddtransferShow = true;
            this.editTf = false;
        },
        transferClose() {
            this.formTf = {
                auprId: '',
                auprNameTo: '',
                auprNameDtTo: '',
                auprDate: '',
            };
            this.AddtransferShow = false;
        },
        transferSure() {
            if (this.editTf) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要新增吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserPostRecord(this.formTf).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "成功!",
                                });
                                this.transferClose()
                                this.transferList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        transferClick(row) {
            this.auId = row.auId;
            getAjUserPostRecordList({ auId: row.auId }).then(res => {
                this.transferData = res.data;
                this.transferShow = true;
            })
        },
        async ob(item) {
            // 防止重复调用
            if (this.obLoading === item) return;
            this.obLoading = item;
            try {
            const filterarr = []
            const data = await getAjUserItem({ item, itemStatus: this.formDatas.checkStatus })

            if (this.formDatas[item + 'ListString']) {
                const arr = this.formDatas[item + 'ListString'].split(',')
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            console.log(datas);
                            const s = {
                                label: ite.name + `[${ite.num}]`,
                                selected: true,
                                value: index
                            }
                            filterarr.push(s)

                        }
                        const s = {
                            label: ite.name + `[${ite.num}]`,
                            selected: true,
                            value: index
                        }
                        filterarr.push(s)
                    })
                })
                let map = new Map();
                let filterList = []
                for (let itt of filterarr) {
                    map.set(itt.id, itt)
                }
                filterList = [...map.values()]
                filterarr = filterList
            } else {
                data.data.forEach((ite, index) => {
                    console.log('初始化');
                    const s = {
                        label: ite.name + `[${ite.num}]`,
                        selected: false,
                        value: index
                    }
                    filterarr.push(s)
                })
            }
            this.$nextTick(() => {
                // 直接在 colgroups 中根据字段名查找对应列，避免索引错乱
                if (this.$refs['vetable'] && this.$refs['vetable'].colgroups) {
                    const targetCol = this.$refs['vetable'].colgroups.find(col => col.field === item);
                    if (targetCol && targetCol.filter) {
                        targetCol.filter.filterList = filterarr;
                    }
                }
            })
            } finally {
                this.obLoading = null;
            }
        },
        CloseConact() {
            this.IsConact = false;
            this.conactType = 0;
        },
        sureConact() {
            if (this.conactType == 1) {
                // 银行卡信息编辑
                updateAjUserBank(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            } else {
                // 家庭信息编辑
                updateAjUserContact(this.form).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                        this.CloseConact()
                        this.getList()
                    }
                })
            }
        },
        getConact(row, type) {
            this.form = JSON.parse(JSON.stringify(row));
            this.conactType = type;
            this.IsConact = true;
        },
        CloseLevel() {
            this.formLevel = {};
            this.IsLevel = false;
        },
        sureLevel() {
            this.$confirm("是否确定要离职吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserLeave(this.formLevel).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "离职成功!",
                            });
                            this.CloseLevel()
                            this.getList()
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        levelDate(row) {
            this.IsLevel = true;
            this.formLevel.auId = row.auId
            this.form.auId = row.auId
        },
        Closeword() {
            this.IsWord = false;
            this.wordtypenum = 1;
            this.wordType = '';
        },
        sureword() {
            exportAjUserWord({
                auId: this.auId, auwId: this
                    .wordType
            }).then(res => {
                if (res.data) {

                    window.location.href = res.data;
                    this.$message({
                        type: "success",
                        message: '导出成功',
                    });
                    this.Closeword()
                }
            })
        },
        Handleword() {
            getAjUserWordList().then(res => {
                this.wordData = res.data;
                this.IsWord = true;
                this.wordtypenum = 1
            })

        },
        expandChange(e) {
            console.log(e);


        },
        handleChange(value) {
            console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.auOrigin = nodesInfo[0].pathLabels.join('/');
            console.log(this.form.auOrigin, nodesInfo)
        },
        expandChange2(e) {
            console.log(e);


        },
        handleChange2(value) {
            console.log(value);
            let nodesInfo = this.$refs['cascader2'].getCheckedNodes()
            this.form.auAddressNow = nodesInfo[0].pathLabels.join(' ');
            console.log(this.form.auAddressNow, nodesInfo)
        },
        sureImg() {
            if (this.type == 1) {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auIdcardUp: this.form.auIdcardUp,
                            auIdcardDown: this.form.auIdcardDown
                        }
                        updateAjUserIdCard(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const s = {
                            auId: this.auId,
                            auCertificateEducation: this.form.auCertificateEducation,
                            auCertificateEducationCheck: this.form.auCertificateEducationCheck
                        }
                        updateAjUserCertificate(s).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

            // 
        },

        handleImg(row, type) {
            this.auId = row.auId;
            this.type = type;
            this.IsImg = true;
            const data = JSON.parse(JSON.stringify(row))
            this.$nextTick(() => {
                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })
        },
        handleHistory(row) {
            getAjUserBorrowReturnList({ auId: row.auId }).then(res => {
                this.HistoryData = res.data;
                this.IsHistory = true;
                this.DjbData = [];
                getAjUserExpandDetails({ auId: row.auId }).then(res => {
                    const s = JSON.parse(res.data.auRequisitionForm);
                    if (s && s.length > 0) {
                        s.forEach((item, index) => {
                            const str = {
                                fileUrl: item
                            }
                            this.DjbData.push(str)
                        })
                    }

                })
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = '';

                this.partserch()
                return
            }
            const arr = labels
            labels.forEach((item, index) => {
                const a = item.indexOf('[');
                arr[index] = item.substring(0, a);

            })
            this.formDatas[id] = arr.toString();

            this.partserch()
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.openLoading()
                uploadImportAjUser({
                    sitId: this.sitId
                }).then(res => {
                    this.loadings.close()
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjUser(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        filterTag(value, row) {
            return row.status == value;
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        handWord(row) {
            this.auId = row.auId
            getAjUserWordList().then(res => {
                this.wordData = res.data;

            })
            this.IsWord = true;
            this.wordtypenum = 2

        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = this.keysId
                    updateAjUser(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id, typeid, Arr) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id;
            this.TypeId = typeid;
            this.EditArr = Arr

        },

        handleCheck(row) {
            this.$confirm("是否确定要审核通过吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjUserCheck({ auId: row.auId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        XlfileChange(file) {
            this.$set(this.form, 'auCertificateEducation', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        CyfileChange(file) {
            this.$set(this.form, 'auCertificateEducationCheck', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        UpremoveAfter() {
            this.form.auNation = '';
            this.form.auBirth = '';
            this.form.auIdcard = '';
            this.form.auIdcardAddress = '';
            this.form.auOrigin = '';
            this.form.auIdcardUp = '';
        },
        DownremoveAfter() {
            this.form.auIdcardIssuingAuthority = '';
            this.form.auIdcardExpiration = '';
            this.form.auIdcardDown = '';
        },
        auIdcardUpfileChange(file) {
            console.log(file);
            if (file[0].idCardInfo) {
                getAjUserDetails({ auIdcard: file[0].idCardInfo.idCardNum }).then(res => {
                    if (res.data && res.data != '资料已审核') {
                        // this.$confirm("该身份证已经存在, 点击确定继续修改,点击取消重新填写?", "提示", {
                        //     confirmButtonText: "确定",
                        //     cancelButtonText: "取消",
                        //     type: "warning",
                        // })
                        //     .then(() => {
                        //         this.$nextTick(() => {
                        //             const sss = JSON.parse(JSON.stringify(res.data))
                        //             this.form = sss;
                        //             this.auOriginPL = res.data.auOrigin;
                        //             const arr = res.data.auEducationLevel.split(' ');

                        //             this.education = arr[0]
                        //             this.form.auEducationLevel = arr[1]
                        //             console.log(arr);
                        //             const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                        //             if (res.data.auAddressNow) {
                        //                 const adress = res.data.auAddressNow.match(reg)
                        //                 const area = adress[0] + adress[1] + adress[2]
                        //                 this.auAddressNowPL = area
                        //             }
                        //             // // 判断银行
                        //             // if (res.data.auBankCardPf) {
                        //             //     this.bankShow = 1
                        //             // } else if (res.data.auBankCardOther || res.data.auBankCardOtherNum || res.data.auBankCardOtherOpen) {
                        //             //     this.bankShow = 2
                        //             // }
                        //             // if (res.data.auContactDad) {
                        //             //     this.familyShow.push('1')

                        //             // } else if (res.data.auContactMom) {
                        //             //     this.familyShow.push('2')
                        //             // } else if (res.data.auContactSibling) {
                        //             //     this.familyShow.push('3')
                        //             // }
                        //             const obj = {
                        //                 UpfileList: 'auIdcardUp',
                        //                 DownfileList: 'auIdcardDown',
                        //                 xlfileList: 'auCertificateEducation',
                        //                 CyfileList: 'auCertificateEducationCheck'
                        //             }
                        //             for (let item in obj) {
                        //                 if (res.data[obj[item]]) {
                        //                     const img = {
                        //                         name: res.data[obj[item]],
                        //                         url: res.data[obj[item]],
                        //                     }
                        //                     this.$set(this[item], 0, img)
                        //                 }
                        //             }
                        //             if (!sss.auIdcardUp) {
                        //                 this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                        //             }

                        //         })

                        //     }).catch(() => {
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            // this.$set(this.auOriginvalue,area)
                            this.auOriginPL = area;
                            this.$forceUpdate()
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            console.log(this.form);
                            console.log(file[0].idCardInfo.address.match(reg))
                            // auAddressRegistered
                        })
                        // })

                    } else {
                        console.log('11');
                        this.$nextTick(() => {
                            const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                            const adress = file[0].idCardInfo.address.match(reg)
                            const area = adress[0] + adress[1] + adress[2]
                            this.$set(this.form, 'auOrigin', area)
                            this.auOriginPL = area;
                            const img = {
                                name: file[0].idCardInfo.cardImageFront,
                                url: file[0].idCardInfo.cardImageFront,
                            }
                            this.$set(this.UpfileList, 0, img)
                            this.$set(this.form, 'auAddressRegistered', file[0].idCardInfo.addressSimple)
                            this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                            this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                            this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                            this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                            this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                            this.$set(this.form, 'auName', file[0].idCardInfo.name)
                            this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                            this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                            console.log(this.form);
                            console.log(file[0].idCardInfo.address.match(reg))
                        })
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });
                    }
                })

            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardUpfileChangeTwo(file) {
            console.log(file);
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    const img = {
                        name: file[0].idCardInfo.cardImageFront,
                        url: file[0].idCardInfo.cardImageFront,
                    }
                    this.$set(this.UpfileList, 0, img)
                    this.$set(this.form, 'auNation', file[0].idCardInfo.nation + '族')
                    this.$set(this.form, 'auBirth', file[0].idCardInfo.birth)
                    this.$set(this.form, 'auIdcard', file[0].idCardInfo.idCardNum)
                    this.$set(this.form, 'auIdcardAddress', file[0].idCardInfo.address)
                    this.$set(this.form, 'auOrigin', file[0].idCardInfo.addressSimple)
                    this.$set(this.form, 'auIdcardUp', file[0].idCardInfo.cardImageFront || file[0].address)
                    this.$set(this.form, 'auName', file[0].idCardInfo.name)
                    this.$set(this.form, 'auSex', file[0].idCardInfo.sex)
                    this.$set(this.form, 'auAge', file[0].idCardInfo.age)
                    console.log(this.form);
                })
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }
        },
        auIdcardDownfileChange(file) {
            if (file[0].idCardInfo) {
                this.$nextTick(() => {
                    const img = {
                        name: file[0].idCardInfo.cardImageBack,
                        url: file[0].idCardInfo.cardImageBack,
                    }
                    this.$set(this.DownfileList, 0, img)
                    this.$set(this.form, 'auIdcardIssuingAuthority', file[0].idCardInfo.issuingAuthority)
                    this.$set(this.form, 'auIdcardExpiration', file[0].idCardInfo.expirationDate)
                    this.$set(this.form, 'auIdcardDown', file[0].idCardInfo.cardImageBack || file[0].address)
                    console.log(this.form);
                })
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            } else {
                this.$message({
                    type: "danger",
                    message: "上传失败!",
                });
            }

        },
        sureRelated() {
            this.$confirm("是否确定要添加吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssets({ auId: this.DetailArr.auId, aaId: this.form.aaId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        addRelated() {
            this.form.aaId = this.DetailArr.ajAssets.aaId || '';
            this.Related = true;
        },
        removeRelated() {
            this.$confirm("是否确定要解除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssetsUnbinding({ auId: this.DetailArr.auId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.auId)
                            this.$message({
                                type: "success",
                                message: "解除成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        closeSizer() {
            this.formDatas = {
                auClothesType: '',
                auClothesStatus: '',
                auName: '',
                auBelong: '',
                auDepartment: '',
                auPost: '',
                auSex: '',
                auIdcard: '',
                auAgeStart: '',
                auAgeEnd: '',
                auDateEntryStart: '',
                auDateEntryEnd: '',
                auStatus: '',
                auInterviewer: '',
                auAddressRegisteredType: '',
                auIdcardExpirationStart: '',
                auIdcardExpirationEnd: '',
                auSchool: '',
                auMajor: '',
                auEducationLevel: '',
                auGraduationTimeStart: '',
                auDateRegularStart: '',
                auDateRegularEnd: '',
                auDateTransferStart: '',
                auDateTransferEnd: '',
                auLevelDateStart: '',
                auLevelDateEnd: '',
                auGraduationTimeEnd: '',
                auEducationLevelMax: '',
                auContactMine: '',
                auSocialSecurityNum: '',
                auProvidentFund: '',
                auInformationEntry: '',
                checkStatus: 2,

                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        getDetail(id) {
            getAjUserDetails({ auId: id, auDataMulti: 1 }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            });

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjUser({ auIds: row.auId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleWc(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formWC.auId = data.auId;
            this.formWC.auClothesType = data.auClothesType;
            this.formWC.auClothesStatus = data.auClothesStatus;
            this.formWC.auClothesStatusDes = data.auClothesStatusDes;
            this.IsWorkClothes = true;
        },
        handleDnb(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formDnb.auId = data.auId;
            this.formDnb.auPackStatus = data.auPackStatus;
            this.formDnb.auPackReturnStatus = data.auPackReturnStatus;
            this.isDnb = true;
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                const arr = data.auEducationLevel.split(' ');
                this.education = arr[0]
                this.form.auEducationLevel = arr[1]
                this.auOriginPL = data.auOrigin;
                const reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则
                // 判断银行
                if (data.auBankCardPf) {
                    this.bankShow = 1
                } else if (data.auBankCardOther || data.auBankCardOtherNum || data.auBankCardOtherOpen) {
                    this.bankShow = 2
                }
                if (data.auContactDad) {
                    this.familyShow.push('1')
                } else if (data.auContactMom) {
                    this.familyShow.push('2')
                } else if (data.auContactSibling) {
                    this.familyShow.push('3')
                }
                if (data.auAddressNow) {

                    const adress = data.auAddressNow.match(reg)
                    const area = adress[0] + adress[1] + adress[2]
                    this.auAddressNowPL = area
                }

                const obj = {
                    UpfileList: 'auIdcardUp',
                    DownfileList: 'auIdcardDown',
                    xlfileList: 'auCertificateEducation',
                    CyfileList: 'auCertificateEducationCheck'
                }
                for (let item in obj) {
                    for (let key in data) {
                        if (key == obj[item] && data[key]) {
                            console.log(data[obj[item]]);
                            const img = {
                                name: data[obj[item]],
                                url: data[obj[item]],
                            }
                            this.$set(this[item], 0, img)
                        }
                    }
                }
            })

        },
        SureBtn() {
            if (!this.edit) {
                this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel;
                console.log(this.form.auEducationLevel);
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.auEducationLevel = this.education + ' ' + this.form.auEducationLevel
                        updateAjUser(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        CloseImg() {
            this.IsImg = false;
            console.log(this.$refs.upcard2);
            setTimeout(() => {
                this.$refs.upcard2.fileAllRemove()
                this.$refs.Downcard2.fileAllRemove()
                this.$refs.xlupload2.fileAllRemove()
                this.$refs.Cyupload2.fileAllRemove()
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            }, 10)
            // this.$nextTick(() => {

            // })


        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            console.log(this.$refs.upcard);
            this.IsImg = false;
            this.bankShow = '';
            this.familyShow = [];
            this.$nextTick(() => {
                this.$refs['formRef'].resetFields();
                this.$refs.upcard.fileAllRemove()
                this.$refs.Downcard.fileAllRemove()
                this.$refs.xlupload.fileAllRemove()
                this.$refs.Cyupload.fileAllRemove()
                this.auAddressNowvalue = '';
                this.auOriginvalue = '';
                this.auAddressNowPL = '请选择地区';
                this.auOriginPL = '请选择地区';
                this.UpfileList = [];
                this.DownfileList = [];
                this.xlfileList = [];
                this.CyfileList = [];
            })


        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auId = row.auId
                    console.log(jsonObj);
                    updateAjUser(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        async beforeCellValChange2(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.auwId = row.auwId
                    console.log(jsonObj);
                    updateAjUserWord(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.wordData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.auId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.auId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.auId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.auId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            // this.formDatas.checkStatus = 2;
            getAjUserListAssets(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            // this.formDatas.checkStatus = 2;
            getAjUserListAssets(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            // this.formDatas.checkStatus = 2;
            getAjUserListAssets(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.tableDataCopy = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td,
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding: 0 !important;
    line-height: 1 !important;
}
</style>